import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ac06954e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"width":"100%"} }
const _hoisted_2 = { style: {"width":"100%"} }
const _hoisted_3 = { style: {"width":"100%"} }
const _hoisted_4 = { style: {"width":"100%"} }
const _hoisted_5 = { class: "sell-group-list" }
const _hoisted_6 = { class: "sell-item" }
const _hoisted_7 = { class: "sell-item" }
const _hoisted_8 = { class: "sell-item" }
const _hoisted_9 = { class: "sell-group-list" }
const _hoisted_10 = { class: "sell-item" }
const _hoisted_11 = { class: "sell-item" }
const _hoisted_12 = { class: "message-ad-box" }
const _hoisted_13 = {
  key: 0,
  class: "message-add"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "message-help" }, " 购买商品时让买家输入留言，最多可设置 10 条留言 ", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#999","margin-left":"5px"} }, "用户展示数=显示购买数+实际购买数", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "submit-fixed-wrap-placeholder" }, null, -1))
const _hoisted_17 = { class: "submit-fixed-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_title = _resolveComponent("ui-title")!
  const _component_ui_radio_card = _resolveComponent("ui-radio-card")!
  const _component_ui_card = _resolveComponent("ui-card")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_ui_upload_image_list = _resolveComponent("ui-upload-image-list")!
  const _component_com_group = _resolveComponent("com-group")!
  const _component_sku = _resolveComponent("sku")!
  const _component_SkuDetail = _resolveComponent("SkuDetail")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_com_postage = _resolveComponent("com-postage")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_MessageRow = _resolveComponent("MessageRow")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_ui_container = _resolveComponent("ui-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_ui_container, { class: "goods-box" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        "label-position": "right",
        "label-width": "150px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ui_card, null, {
            title: _withCtx(() => [
              _createVNode(_component_ui_title, { title: "基本信息" })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_ui_radio_card, {
                list: _ctx.goodsType,
                modelValue: _ctx.formData.type,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.type) = $event))
              }, null, 8, ["list", "modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_ui_card, null, {
            title: _withCtx(() => [
              _createVNode(_component_ui_title, { title: "商品类型" })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "商品名" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.name,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.name) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "商品简介" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.description,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.description) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "封面图" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_ui_upload_image_list, {
                      modelValue: _ctx.formData.cover,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.cover) = $event)),
                      class: "goods-upload-list-box"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "商品图" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_ui_upload_image_list, {
                      modelValue: _ctx.formData.image,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.image) = $event)),
                      limit: "0",
                      class: "goods-upload-list-box"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "商品视频" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_ui_upload_image_list, {
                      modelValue: _ctx.formData.video,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.video) = $event)),
                      "data-type": "array",
                      type: "2",
                      "url-pipe": _ctx.processVideo,
                      class: "goods-upload-list-box"
                    }, null, 8, ["modelValue", "url-pipe"])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_com_group, {
                modelValue: _ctx.formData.categoryId,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.categoryId) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_el_form_item, { label: "商品排序" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.sort,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.sort) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ui_card, null, {
            title: _withCtx(() => [
              _createVNode(_component_ui_title, { title: "商品信息" })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "商品规格" }, {
                default: _withCtx(() => [
                  _createVNode(_component_sku, {
                    modelValue: _ctx.formData.spec,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.spec) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _withDirectives(_createVNode(_component_el_form_item, { label: "规格明细" }, {
                default: _withCtx(() => [
                  (!_ctx.loading)
                    ? (_openBlock(), _createBlock(_component_SkuDetail, {
                        key: 0,
                        modelValue: _ctx.formData.skuList,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.skuList) = $event)),
                        sku: _ctx.formData.spec
                      }, null, 8, ["modelValue", "sku"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 512), [
                [_vShow, _ctx.formData.spec.length]
              ]),
              _createVNode(_component_el_form_item, { label: "显示价" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.showPrice,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.showPrice) = $event)),
                    style: {"width":"200px"}
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "划线价" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.originPrice,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.originPrice) = $event)),
                    style: {"width":"200px"}
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.formData.type != 2)
            ? (_openBlock(), _createBlock(_component_ui_card, { key: 0 }, {
                title: _withCtx(() => [
                  _createVNode(_component_ui_title, { title: "物流信息" })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "配送方式" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_checkbox, {
                        onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.changeExpressType(1, $event))),
                        "model-value": (_ctx.formData.expressType & 1) > 0
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("快递发货")
                        ]),
                        _: 1
                      }, 8, ["model-value"]),
                      _createVNode(_component_el_checkbox, {
                        "model-value": (_ctx.formData.expressType & 2) > 0,
                        onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.changeExpressType(2, $event)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("到店自提 ")
                        ]),
                        _: 1
                      }, 8, ["model-value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_com_postage, {
                    modelValue: _ctx.formData.postageId,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.postageId) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_ui_card, null, {
            title: _withCtx(() => [
              _createVNode(_component_ui_title, { title: "其他信息" })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "最小购买数" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input_number, {
                    modelValue: _ctx.formData.minBuy,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.minBuy) = $event)),
                    "controls-position": "right",
                    min: 1,
                    max: 9999
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "开售时间" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: _ctx.formData.sellStatus,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.sellStatus) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_el_radio, { label: 1 }, {
                            default: _withCtx(() => [
                              _createTextVNode("立即开售")
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_component_el_radio, { label: 2 }, {
                            default: _withCtx(() => [
                              _createTextVNode("定时开售")
                            ]),
                            _: 1
                          }),
                          (_ctx.formData.sellStatus == 2)
                            ? (_openBlock(), _createBlock(_component_el_date_picker, {
                                key: 0,
                                modelValue: _ctx.formData.sellStartTime,
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.sellStartTime) = $event)),
                                type: "datetime",
                                placeholder: "选择开售时间"
                              }, null, 8, ["modelValue"]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_el_radio, { label: 0 }, {
                            default: _withCtx(() => [
                              _createTextVNode("下架")
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "购买按钮文本" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: _ctx.formData.buyButtonType,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData.buyButtonType) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_el_radio, { label: 1 }, {
                            default: _withCtx(() => [
                              _createTextVNode("默认名称")
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_el_radio, { label: 2 }, {
                            default: _withCtx(() => [
                              _createTextVNode("自定义名称")
                            ]),
                            _: 1
                          }),
                          (_ctx.formData.buyButtonType == 2)
                            ? (_openBlock(), _createBlock(_component_el_input, {
                                key: 0,
                                maxlength: "6",
                                modelValue: _ctx.formData.buyButton,
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.buyButton) = $event)),
                                placeholder: "请输入自定义名称"
                              }, null, 8, ["modelValue"]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "留言" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.message, (item, index) => {
                      return (_openBlock(), _createBlock(_component_MessageRow, {
                        key: index,
                        modelValue: item,
                        style: {"margin-bottom":"10px"},
                        onDelete: ($event: any) => (_ctx.formData.message.splice(index, 1))
                      }, null, 8, ["modelValue", "onDelete"]))
                    }), 128)),
                    _createElementVNode("div", _hoisted_12, [
                      (_ctx.formData.message.length < 10)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createElementVNode("span", {
                              onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.addRow && _ctx.addRow(...args)))
                            }, "添加字段")
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_14
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "显示购买数" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.buyNum,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData.buyNum) = $event)),
                    style: {"width":"200px"}
                  }, null, 8, ["modelValue"]),
                  _hoisted_15
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _withDirectives((_openBlock(), _createBlock(_component_el_button, { onClick: _ctx.submit }, {
              default: _withCtx(() => [
                _createTextVNode("直接保存")
              ]),
              _: 1
            }, 8, ["onClick"])), [
              [_directive_loading, _ctx.submitLoading]
            ]),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.$emit('change-step', 1)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("下一步")
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}